import React, { useState, useEffect } from 'react';
import { Chip, CircularProgress } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';
import { snowflakeApi } from '../../utils/api';
import { useDatabaseMode } from '../../context/DatabaseModeContext';

interface DatabaseStatusIndicatorProps {
  className?: string;
}

const DatabaseStatusIndicator: React.FC<DatabaseStatusIndicatorProps> = ({ className }) => {
  // Health check polling disabled - assume connected since user is actively using the app
  const [dbStatus, setDbStatus] = useState<'connected' | 'disconnected' | 'checking'>('connected');
  const { isUsingDatabaseApproach } = useDatabaseMode();
  
  // DISABLED: Health check polling to reduce console noise
  // useEffect(() => {
  //   const checkDatabaseStatus = async () => {
  //     try {
  //       // Check if database is enabled and connected
  //       const response = await snowflakeApi.get('/api/v1/module1/health');
  //       const isDbEnabled = response.data?.checks?.database === 'ok' || isUsingDatabaseApproach;
  //       
  //       setDbStatus(isDbEnabled ? 'connected' : 'disconnected');
  //     } catch (error) {
  //       console.error('Error checking database status:', error);
  //       setDbStatus('disconnected');
  //     }
  //   };
  //   
  //   // Check immediately
  //   checkDatabaseStatus();
  //   
  //   // Check periodically (reduced frequency to avoid spam)
  //   const interval = setInterval(checkDatabaseStatus, 120000); // Every 2 minutes
  //   
  //   return () => clearInterval(interval);
  // }, []);
  
  return (
    <Chip
      className={className}
      variant="outlined"
      icon={
        dbStatus === 'connected' ? <CheckCircle /> : 
        dbStatus === 'disconnected' ? <Error /> : 
        <CircularProgress size={16} />
      }
      label={
        dbStatus === 'connected' ? 'Database Connected' :
        dbStatus === 'disconnected' ? 'Database Offline' :
        'Checking Database...'
      }
      color="default"
      size="small"
      sx={{
        '& .MuiChip-icon': {
          fontSize: 16,
          color: dbStatus === 'connected' ? '#1B5E20' : undefined, // Dark green
        },
        ...(dbStatus === 'connected' && {
          borderColor: '#1B5E20', // Dark green border
          color: '#1B5E20', // Dark green text
        })
      }}
    />
  );
};

export default DatabaseStatusIndicator; 